import React, { useState } from 'react';
import { ArrowUpRight, RefreshCw } from 'lucide-react';
import { Button } from '../ui/button';
import { paymentApi, paymentError } from './api';

export const BillingControls = ({ info, onRefresh }) => {
  const [busy, setBusy] = useState(false), [error, setError] = useState('');
  const manage = async () => {
    if (busy) return;
    setBusy(true); setError('');
    try {
      const { data } = await paymentApi.post('/payments/billing-portal');
      const destination = new URL(data.url);
      if (destination.protocol !== 'https:' || destination.hostname !== 'billing.stripe.com') throw new Error('Invalid billing destination');
      window.location.assign(destination.href);
    } catch (exception) { setError(paymentError(exception)); }
    finally { setBusy(false); }
  };
  if (!info?.can_manage_billing) return null;
  return <div className="mt-5 space-y-3" data-testid="membership-billing-controls">
    <p className="membership-muted" data-testid="membership-subscription-status">Subscription: {info.subscription_status?.replaceAll('_', ' ')}
      {info.paid_through ? ` · ${info.cancel_at_period_end ? 'Ends' : 'Paid through'} ${new Date(info.paid_through * 1000).toLocaleDateString()}` : ''}</p>
    {info.cancel_at_period_end && <p className="membership-message" data-testid="membership-cancellation-notice">Renewal is canceled. Paid access continues until the end of your billing period. Permanent exemptions are unaffected.</p>}
    <Button variant="outline" data-testid="membership-manage-billing" disabled={busy} onClick={manage}>{busy ? 'Opening…' : 'Manage billing'}<ArrowUpRight size={16} /></Button>
    <Button variant="ghost" data-testid="membership-refresh-billing" disabled={busy} onClick={onRefresh}><RefreshCw size={16} />Refresh</Button>
    <p className="membership-muted" data-testid="membership-billing-policy">Update your payment method, view invoices, or cancel future renewals in Stripe.</p>
    {error && <p role="alert" className="membership-error" data-testid="membership-billing-error">{error}</p>}
  </div>;
};